// extracted by mini-css-extract-plugin
module.exports = {"popovermenu":"__popovermenu__xLyUJ","popovermenu-fixed":"__popovermenu-fixed__yrdCM"};